import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import css from './OrderPanel.module.css'; // Assuming shared CSS module
import Icons from '../Icons/Icons';
import { IconSpinner, SecondaryButton } from '..';

const WishlistButton = ({
  shouldHideHeaderSection,
  isAlreadyAddedToWishlist,
  currentFavoriteId,
  listingId,
  isOwnListing,
  onClick,
  className: additionalClassName, // For overrides beyond defaults
  ...buttonProps // For additional props like type, disabled, etc.
}) => {
  if (shouldHideHeaderSection || isOwnListing) {
    return null;
  }

  const buttonClassName = classNames(
    css.makeOfferButton,
    css.bookmark,
    isAlreadyAddedToWishlist ? css.filled : css.unfilled,
    additionalClassName
  );

  const isLoading = currentFavoriteId === listingId;

  return (
    <SecondaryButton className={buttonClassName} onClick={onClick} type="button" {...buttonProps}>
      {isLoading ? (
        <IconSpinner />
      ) : (
        <>
          <Icons name={isAlreadyAddedToWishlist ? 'heartFilled' : 'heart'} />
          <FormattedMessage id="OrderPanel.favorite" />
        </>
      )}
    </SecondaryButton>
  );
};

WishlistButton.propTypes = {
  shouldHideHeaderSection: PropTypes.bool.isRequired,
  isAlreadyAddedToWishlist: PropTypes.bool.isRequired,
  currentFavoriteId: PropTypes.string, // or whatever type it is
  listingId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default WishlistButton;
